import "@babel/polyfill";
import "intersection-observer";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import Vue from "vue";
import { sync } from "vuex-router-sync";
import VueObserveVisibility from "vue-observe-visibility";
import VueMatomo from "vue-matomo";
import PortalVue from "portal-vue";
import VueVirtualScroller from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "@/plugins/vuetify"; // use vuetify and import styles
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import i18n from "@/i18n";
import { capitalize } from "@/filters";
import "@/assets/fonts/index.css";
import getMatomoConfig from "../matomo.config";

if (window.navigator && navigator.serviceWorker) {
  // Removes broken service worker registrations
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach((registration: ServiceWorkerRegistration) => {
      registration.unregister();
    });
  });
}

Vue.use(VueObserveVisibility);
Vue.use(PortalVue);
Vue.use(VueVirtualScroller);

// sync router in vuex state
sync(store, router);

Vue.config.productionTip = false;
Vue.filter("capitalize", capitalize);

async function awaitStageConfig() {
  // @ts-ignore
  if (!store.state.stageconfig.config) {
    await store.dispatch("stageconfig/fetchStageConfig");
  }
}

awaitStageConfig()
  .then(function success() {
    /**
     * Matomo (Tracking) Configuration
     */
    // @ts-ignore
    if (store.state.stageconfig.config.features.enableMatomoTracking) {
      Vue.use(VueMatomo, getMatomoConfig(router));
    }

    // @ts-ignore
    if (store.state.stageconfig.config.features.enableHotjar) {
      const hotjarTrackingScript = document.createElement("script");
      hotjarTrackingScript.setAttribute("type", "text/plain");
      hotjarTrackingScript.setAttribute("class", "optanon-category-C0002");
      hotjarTrackingScript.setAttribute("src", "/hotjar.js");
      document.head.appendChild(hotjarTrackingScript);
    }
    /**
     * Sentry Error Logging
     */
    Sentry.init({
      Vue,
      dsn:
        "https://ff200b42db4d4c599a557631dd280657@o1063741.ingest.sentry.io/6352461",
      integrations: [
        new BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          tracingOrigins: ["app.dpa-select.de"]
        })
      ],
      ignoreErrors: [
        "Network Error",
        "unknown",
        "ChunkLoadError",
        "Non-Error promise rejection captured with value"
      ],
      // We have set the tracesSampleRate from 1.0 to 0.5 to reduce the transaction counts in the sentry.
      tracesSampleRate: 0.5,
      // @ts-ignore
      environment: store.state.stageconfig.config.stage
    });

    new Vue({
      router,
      store,
      i18n,
      render: h => h(App)
    }).$mount("#app");
  })
  .catch(err => console.log(err));
